import {
    Avatar,
    Box,
    Heading,
    HStack,
    Text,
    VStack,
} from "@chakra-ui/react";
import Navbar from "./components/navbar";
import DefaultLayout from "../../layouts/default";
import { Outlet } from "react-router-dom";

const Settings = () => {
    return (
        <DefaultLayout withFooter={false}>
            <VStack alignItems={"start"} px={20} gap={"2rem"} pt={5}>
                <HStack width={"100%"}>
                    <Avatar />
                    <Heading size={"sm"} m={0}>Leandro Hernandez </Heading>
                    <Text m={0}>(altmoket)</Text>
                    {/* <Heading size={'sm'} m={0}>altmoket</Heading> */}
                </HStack>

                <HStack alignItems={"flex-start"} w={"100%"} gap={'5rem'}>
                    <Box>
                        <Navbar></Navbar>
                    </Box>
                    <Box width={'100%'}>
                        <Outlet />
                    </Box>
                </HStack>
            </VStack>
        </DefaultLayout>
    );
};

export default Settings;
